export default __webpack_public_path__ + "static/media/check.8e57f36d.svg";